import { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";
// components
import {
  // Menu,
  AboutSection,
  ScheduleSection,
  FAQSection,
  SponsorSection,
  // DungeonSection,
  // FooterSection,
} from "../components";
import FooterSection from "../components/FooterSection";
// assets
// import banner from "../assets/svgs/banner.svg";
// import banner_with_date from "../assets/svgs/banner_with_date.svg";
import banner_gif from "../assets/gifs/banner_school_date.gif";
import sword from "../assets/svgs/sword.svg";
import knight_loop from "../assets/gifs/knight_loop.gif";
// import dungeon from "../assets/svgs/dungeon.svg";
import dungeon2 from "../assets/svgs/dungeon2.svg";
// styles
const background_style = {
  fontFamily: "Aldo",
  minHeight: "100vh",
  background: "#1E3533",
  color: "#7EC0AE",
};
const banner_style = {
  width: "100%",
  // backgroundSize: "contain",
};
// const menu_style = {
//   background: "#D8F8FC",
// };
// const knight_style = {
//   width: "80%",
// };
const sword_style = {
  width: "50%",
  padding: "2%",
  cursor: "pointer",
};
const mobile_sword_style = {
  width: "75%",
  padding: "2%",
  marginTop: "5%",
  marginBottom: "5%",
  cursor: "pointer",
};
const about_style = {
  marginLeft: "3%",
};
const mobile_about_style = {
  marginLeft: "10%",
  marginRight: "10%",
};

const knight_style = {
  width: "100%",
};
const mobile_knight_style = {
  width: "250%",
};
// animations
const SideFloatingImg = styled.img`
  width: 20vw;
  animation: x_floating 3s infinite;
  @keyframes x_floating {
    0% {
      transform: translate(0, 0px);
    }
    50% {
      transform: translate(25px, 0);
    }
    100% {
      transform: translate(-0px, 0);
    }
  }
`;
// ##########################
// Component
// ##########################
const Home = () => {
  // conditional rendering
  const [isDesktop, setDesktop] = useState(window.innerWidth > 960);
  const updateMedia = () => {
    setDesktop(window.innerWidth > 960);
  };
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  return (
    <div style={background_style}>
      {/* <div style={menu_style}>
        <Container>
          <div>
            <Menu />
          </div>
        </Container>
      </div> */}

      <div>
        <img
          src={banner_gif}
          alt="banner"
          style={banner_style}
          // onClick={() => {
          // 	window.open("https://twitter.com/swamphacks", "_blank");
          // }}
        />
      </div>

      <Link to="/apply">
        <Row style={{ display: "grid", placeItems: "center" }}>
          <SideFloatingImg
            src={sword}
            alt="sword"
            style={isDesktop ? sword_style : mobile_sword_style}
          />
        </Row>
      </Link>

      <Row style={isDesktop ? about_style : mobile_about_style} id="About">
        <AboutSection />
      </Row>
      <Row className="m-5" id="Schedule">
        <ScheduleSection />
      </Row>
      <Row className="m-5" id="FAQ">
        <FAQSection />
      </Row>

      <div>
        <img
          src={knight_loop}
          style={isDesktop ? knight_style : mobile_knight_style}
          alt="knight"
        />
      </div>

      <Row className="m-5" id="Sponsors">
        <SponsorSection />
      </Row>

      {/* <Row className="my-4">
        <DungeonSection />
      </Row> */}

      <Row>
        <img src={dungeon2} alt="dungeon" style={{ width: "100%" }} />
      </Row>

      <FooterSection />
    </div>
  );
};

export default Home;
